import { useLocation } from 'wouter';
import { useCareRecipientView } from '@/contexts/care-recipient-view-context';

/**
 * A hook to determine if the current view should be read-only
 * This checks both the URL query parameter and the Care Recipient View context
 */
export function useViewOnlyMode() {
  const [location] = useLocation();
  const { isInCareRecipientView } = useCareRecipientView();
  
  // Use URLSearchParams for proper query parameter parsing
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);
  
  // Check if URL has view-only parameter
  const hasViewOnlyParam = params.get('mode') === 'view-only' || location.includes('mode=view-only');
  
  // Check if we're in care recipient view from the URL params
  const hasCareRecipientViewParam = params.get('careRecipientView') === 'true' || location.includes('careRecipientView=true');
  
  const result = hasViewOnlyParam || hasCareRecipientViewParam || isInCareRecipientView;
  
  console.log('useViewOnlyMode() result:', { 
    result,
    hasViewOnlyParam,
    hasCareRecipientViewParam,
    isInCareRecipientView,
    location,
    params: Object.fromEntries(params.entries())
  });
  
  // Return true if any of these conditions are met
  return result;
}